import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/arrow-right.svg'
import _imports_1 from '../../../public/images/new/onlinecare_jumbotron.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-6212297a")

_pushScopeId("data-v-6212297a")
const _hoisted_1 = { class: "-royalBlue" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "Online Care"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Jumbotorn = _resolveComponent("Jumbotorn")

  return (_openBlock(), _createBlock(_component_Jumbotorn, { class: "onlinecare-intro" }, {
    header: _withId(() => [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.t("medically-vulnerable")), 1)
    ]),
    main: _withId(() => [
      _createVNode("span", null, _toDisplayString(_ctx.t("online-care-intro-1")), 1),
      _hoisted_2,
      _createVNode("span", null, _toDisplayString(_ctx.t("online-care-intro-2")), 1)
    ]),
    footer: _withId(() => [
      _createVNode(_component_router_link, {
        to: _ctx.linkTo,
        class: "btn-arrow-right"
      }, {
        default: _withId(() => [
          _createVNode("span", null, _toDisplayString(_ctx.t("take appointment")), 1),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    image: _withId(() => [
      _createVNode("figure", {
        class: !!_ctx.isMobileShow ? '' : ''
      }, [
        _hoisted_4
      ], 2)
    ]),
    _: 1
  }))
})